import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { AppState } from '../app';
import { ContactAttributeViewModel } from '@/messaging/models/contactAttributeViewModel';

export interface AttributesState {
  contactAttributes: ContactAttributeViewModel[];
}

// initial state
export const attributeState: AttributesState = {
  contactAttributes: [],
};

export const attributes: Module<AttributesState, AppState> = {
  namespaced: false,
  state: attributeState,
  actions,
  getters,
  mutations,
};
